// extracted by mini-css-extract-plugin
module.exports = {"questionMarkWrapper":"HoverCard_questionMarkWrapper__1PZ22","informationCardWrapper":"HoverCard_informationCardWrapper__iKAoQ"};